import * as types from './types';
import {setAuthHeader} from 'api/base';
import * as api from 'api/account';


export const setCurrentAccount = (user) => ({
    type: types.SET_CURRENT_ACCOUNT,
    user,
});

export const setAuthInfo = token => {
    localStorage.setItem('cwbJwt', token);
    setAuthHeader(token);
};

export const removeAuthInfo = () => {
    localStorage.removeItem('cwbJwt');
    setAuthHeader(false);
};

export const fetchCurrentAccount = () => {
    setAuthHeader(localStorage.getItem('cwbJwt'));
    return dispatch => api.fetchCurrentAccount()
        .then(response => {
            dispatch(setCurrentAccount(response.record));
            return response;
        })
        .catch((error) => {
            removeAuthInfo();
            return Promise.reject(error);
        });
};

export const login = (payload) => (
    (dispatch) => api.login(payload).then(response => {
        setAuthInfo(response.token);
        dispatch(setCurrentAccount(response.user));
        return response;
    })
);

export const logout = () => (
    (dispatch) => new Promise((resolve) => {
        removeAuthInfo();
        dispatch(setCurrentAccount());
        resolve();
    })
);
